import { DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE } from "../reducers/dashboard";
import { ReduxActionGeneric } from "./types";

export type DashboardReduxReducerUpgradeUserPlanToProServices = "invoice";
export type DashboardReduxReducerUpgradeUserPlanToStandardServices = "onlineShop";

type DashboardReduxReducerActions = {
  showUpgradeUserPlanToProModal: (
    service: DashboardReduxReducerUpgradeUserPlanToProServices
  ) => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SHOW_UPGRADE_USER_PLAN_TO_PRO_MODAL,
    DashboardReduxReducerUpgradeUserPlanToProServices
  >;

  hideUpgradeUserPlanToProModal: () => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.HIDE_UPGRADE_USER_PLAN_TO_PRO_MODAL,
    undefined
  >;
  showUpgradeUserPlanToStandardModal: (
    service: DashboardReduxReducerUpgradeUserPlanToStandardServices
  ) => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SHOW_UPGRADE_USER_PLAN_TO_STANDARD_MODAL,
    DashboardReduxReducerUpgradeUserPlanToStandardServices
  >;

  hideUpgradeUserPlanToStandardModal: () => ReduxActionGeneric<
    typeof DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.HIDE_UPGRADE_USER_PLAN_TO_STANDARD_MODAL,
    undefined
  >;
};

export const dashboardReduxReducerActions: DashboardReduxReducerActions = {
  showUpgradeUserPlanToProModal(service) {
    return {
      payload: service,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SHOW_UPGRADE_USER_PLAN_TO_PRO_MODAL,
    };
  },
  hideUpgradeUserPlanToProModal() {
    return {
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.HIDE_UPGRADE_USER_PLAN_TO_PRO_MODAL,
    };
  },
  showUpgradeUserPlanToStandardModal(service) {
    return {
      payload: service,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SHOW_UPGRADE_USER_PLAN_TO_STANDARD_MODAL,
    };
  },
  hideUpgradeUserPlanToStandardModal() {
    return {
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.HIDE_UPGRADE_USER_PLAN_TO_STANDARD_MODAL,
    };
  },
};

export type DashboardReduxReducerActionsReturn = ReturnType<
  DashboardReduxReducerActions[keyof DashboardReduxReducerActions]
>;
